var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-section container px-3"},[_c('h2',{staticClass:"content-section-title mb-0"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.adatpersInfo),function(adapters,i){return _c('Adapter',{key:i,attrs:{"adapters":adapters}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }